var map = {
	"./1/symbol_0.png": "15b6",
	"./1/symbol_1.png": "c972",
	"./1/symbol_10.png": "67ac4",
	"./1/symbol_11.png": "de4a",
	"./1/symbol_12.png": "34e8",
	"./1/symbol_2.png": "0c67",
	"./1/symbol_3.png": "edb4",
	"./1/symbol_4.png": "7653",
	"./1/symbol_5.png": "5bd0",
	"./1/symbol_6.png": "808c",
	"./1/symbol_7.png": "50cc",
	"./1/symbol_8.png": "2608",
	"./1/symbol_9.png": "b0e1",
	"./2/symbol_0.png": "1473",
	"./2/symbol_1.png": "c57b",
	"./2/symbol_10.png": "1baf",
	"./2/symbol_11.png": "c6b0",
	"./2/symbol_12.png": "b018",
	"./2/symbol_2.png": "ed80",
	"./2/symbol_3.png": "7065",
	"./2/symbol_4.png": "9cca4",
	"./2/symbol_5.png": "577f",
	"./2/symbol_6.png": "22cf",
	"./2/symbol_7.png": "4d77",
	"./2/symbol_8.png": "05a5",
	"./2/symbol_9.png": "4a0d",
	"./3/symbol_0.png": "81f9",
	"./3/symbol_1.png": "0548",
	"./3/symbol_10.png": "4ff7",
	"./3/symbol_12.png": "4148",
	"./3/symbol_2.png": "f3b6",
	"./3/symbol_3.png": "7091",
	"./3/symbol_4.png": "92ea",
	"./3/symbol_5.png": "3b03",
	"./3/symbol_6.png": "ba37",
	"./3/symbol_7.png": "0923",
	"./3/symbol_8.png": "8d24",
	"./3/symbol_9.png": "db0c",
	"./4/symbol_0.png": "3d03",
	"./4/symbol_1.png": "37b8",
	"./4/symbol_10.png": "8ce5",
	"./4/symbol_12.png": "ffa7",
	"./4/symbol_2.png": "823c",
	"./4/symbol_3.png": "bea3",
	"./4/symbol_4.png": "5252",
	"./4/symbol_5.png": "6707",
	"./4/symbol_6.png": "0ed0",
	"./4/symbol_7.png": "d41a",
	"./4/symbol_8.png": "3340",
	"./4/symbol_9.png": "4272",
	"./gold1.png": "99e5",
	"./gold2.png": "33aa",
	"./gold3.png": "0252",
	"./gold4.png": "9912",
	"./header_slotmachine_freespin._no_fg.png": "e155",
	"./silver1.png": "5cd7",
	"./silver2.png": "297d",
	"./silver3.png": "b495",
	"./silver4.png": "1b2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe64";